 import React from 'react'
 import AboutImg from "../images/about/about-3.jpg"
 import "../styles/about.css"
import { useEffect } from 'react';
import { useRef } from 'react';
 const AboutUs = () => {

     const servicesRef = useRef(null);
      
   useEffect (() => {
    const revealElements = servicesRef.current.querySelectorAll("[data-reveal]");
     const scrollReveal = () => {
        for (let i = 0; i < revealElements.length; i++) {
         const elementIsInScreen =
        revealElements[i].getBoundingClientRect().top < window.innerHeight / 1.15;
      
      if (elementIsInScreen) {
       revealElements[i].classList.add("revealed");
       } else {
          revealElements[i].classList.remove("revealed");
           }
        }
       };
      
       window.addEventListener("scroll", scrollReveal);
          scrollReveal(); // Initial check
      
          return () => {
            window.removeEventListener("scroll", scrollReveal);
          };
        }, []);

   return (
    <>
    <div  id="about-us" ref={servicesRef}>
<section  className="about-tuwe section" >
  <div className="container">
    {/* Section Title */}
    <div className="section-title text-center" data-aos="fade-up">
      <span className="subtitle" data-reveal>Who We Are</span>
      <h3 data-reveal>About Us</h3>
    </div>

    <div className="row align-items-center gy-5">
      {/* Text Content */}
      <div
        className="col-lg-6"
        data-aos="fade-up"
        data-aos-delay="100"
      >
        <div className="about-tuwe-content">
      <p className="lead-text" data-reveal>
       Tuwe Initiative&trade; is a locally founded NGO supporting underserved young women
with last-mile access to digital tools, AI skills, mentorship, confidence-building,
and practical pathways into learning, work, and enterprise through the Last-Mile
Education Delivery Model (L-MEDM™).


      </p>


          <p data-reveal>
Tuwe Initiative works with young women who have fallen through the cracks of the
education system to build a pathway to livelihoods and economic independence. It does
this by providing the digital, and relational infrastructure that enables young women and
first-generation learners to access quality digi9tal skills as well as accredited post-
secondary education without leaving their communities.
          </p>

   

          <p data-reveal>
By bridging access and opportunity, Tuwe transforms post- secondary education from a
distant privilege into a reachable pathway for those who would otherwise be excluded.
      
          </p>
        </div>
 
      </div>

      {/* Image Content */}
      <div
        className="col-lg-6 tuwe-img-wrapper"
        data-aos="fade-up"
        data-aos-delay="200"
        data-reveal
      >
        <div className="about-tuwe-image" >
          <img
            src={AboutImg}
            alt="About Tuwe Initiative"
            className=" "
          />
        </div>
      </div>
    </div>
  </div>
</section>
{/* /About Tuwe Initiative Section */}
<section id="our-story" className="mt-3 tuwe-timeline section">

  <div className="container">

    <div className="section-title text-center" data-aos="fade-up">
      <span className="subtitle" data-reveal>Where Tuwe Comes From</span>
      <h3 data-reveal>Our Story</h3>
    </div> 

    {/* Timeline Item 1 */}
    <div className="timeline-row mt-3" data-aos="fade-up">
      <div className="timeline-marker" data-reveal="left ">
        <span>Early Years</span>
      </div>
      <div className="timeline-content">
        <h4 data-reveal>Rooted in Lived Experience</h4>
        <p data-reveal>
          Tuwe Initiative is more than a name, it is rooted in lived experience.
          The organization was founded by Elizabeth Ng’ang’a, whose education
          journey was shaped by poverty, disruption, and systemic exclusion.
          Raised in a rural village in Kiambu County, school attendance was often
          interrupted due to unpaid fees.
        </p>
      </div>
    </div>

    {/* Timeline Item 2 */}
    <div className="timeline-row" data-aos="fade-up" data-aos-delay="100">
      <div className="timeline-marker"data-reveal="left">
        <span>After High School</span>
      </div>
      <div className="timeline-content">
        <h4 data-reveal>Potential Without Access</h4>
        <p data-reveal>
          Although Elizabeth completed high school, cumulative disruptions meant
          she did not attain the grades required for scholarships or entry into
          public university, despite her capability and ambition. Like many young
          people in similar circumstances, she pursued alternative pathways,
          enrolling in a diploma programme and later entering the workforce on
          minimal wages.
        </p>
      </div>
    </div>

    {/* Timeline Item 3 */}
    <div className="timeline-row" data-aos="fade-up" data-aos-delay="200">
      <div className="timeline-marker" data-reveal="left">
        <span>Adulthood</span>
      </div>
      <div className="timeline-content">
        <h4 data-reveal>Balancing Responsibility and Education</h4>
        <p data-reveal>
          Over time, she balanced full-time employment, motherhood, and family
          responsibilities while continuing to pursue education. Through
          determination and family sacrifice, she completed a degree in
          Integrated Community Development.
        </p>
      </div>
    </div>

    {/* Timeline Item 4 */}
    <div className="timeline-row" data-aos="fade-up" data-aos-delay="300">
      <div className="timeline-marker" data-reveal="left">
        <span>Global Aspirations</span>
      </div>
      <div className="timeline-content">
        <h4 data-reveal>Systemic Barriers Revealed</h4>
        <p data-reveal>
          Elizabeth’s aspiration for further education and global exposure
          persisted. Despite gaining admission to international universities,
          she encountered familiar barriers: partial scholarships that could not
          be topped up, relocation requirements incompatible with caregiving
          responsibilities, and inaccessible education financing mechanisms.
        </p>
      </div>
    </div>

    {/* Timeline Item 5 */}
    <div className="timeline-row" data-aos="fade-up" data-aos-delay="400">
      <div className="timeline-marker" data-reveal="left">
        <span>The Realization</span>
      </div>
      <div className="timeline-content">
        <h4 data-reveal>From Personal Struggle to Collective Solution</h4>
        <p data-reveal>
          After approaching dozens of institutions and individuals without
          success, it became clear that the challenge was not individual effort,
          but structural exclusion. This realization became the foundation of
          Tuwe Initiative.
        </p>
      </div>
    </div>

  </div>

</section>
</div>
    </>
   )
 }
 
 export default AboutUs